import * as Immutable from "immutable";
import Parameters from "enterprise/parameters/components/Parameters";
import OptionParameter from "enterprise/parameters/components/option/OptionParameter";
import useParameters from "views/hooks/useParameters";
import ParameterBinding from "views/logic/parameters/ParameterBinding";
import { setParameterValues } from "views/logic/slices/searchExecutionSlice";
const parameterIsRequired = (parameter) => parameter.needsBinding && !parameter.optional && parameter.type !== OptionParameter.type;
const onParameterSubmit = async ({ parameterBindings }, dispatch) => {
  if (parameterBindings) {
    const newParameterBindings = Immutable.Map(Object.entries(parameterBindings != null ? parameterBindings : {}));
    await dispatch(setParameterValues(newParameterBindings));
  }
  return Promise.resolve(void 0);
};
const useInitialParameterValues = () => {
  const { parameterBindings } = useParameters();
  return {
    parameterBindings: parameterBindings.mapEntries(([fieldName, { value }]) => [fieldName, value]).toObject()
  };
};
const parameterMap = (parameters = Immutable.Set()) => Immutable.Map(parameters.map((p) => [p.name, p]));
const parameterSearchBarControls = {
  id: "parameter-input-bar",
  component: Parameters,
  useInitialSearchValues: useInitialParameterValues,
  useInitialDashboardWidgetValues: useInitialParameterValues,
  onSearchSubmit: onParameterSubmit,
  onDashboardWidgetSubmit: onParameterSubmit,
  validationPayload: (values, handlerContext) => {
    var _a, _b;
    const view = handlerContext == null ? void 0 : handlerContext.view;
    const parameters = parameterMap((_a = view == null ? void 0 : view.search) == null ? void 0 : _a.parameters);
    const parameterBindings = Object.fromEntries(
      Object.entries((_b = values.parameterBindings) != null ? _b : {}).map(([fieldName, value]) => [
        fieldName,
        ParameterBinding.forValue(value)
      ])
    );
    return { parameters: parameters.toArray(), parameter_bindings: parameterBindings };
  },
  onValidate: ({ parameterBindings }, handlerContext) => {
    var _a, _b;
    const view = handlerContext == null ? void 0 : handlerContext.view;
    const parameters = parameterMap((_a = view == null ? void 0 : view.search) == null ? void 0 : _a.parameters);
    const parametersWhichNeedABinding = (_b = parameters == null ? void 0 : parameters.filter(parameterIsRequired)) != null ? _b : Immutable.List();
    const parameterErrors = parametersWhichNeedABinding.map(({ name }) => [name, !(parameterBindings == null ? void 0 : parameterBindings[name]) && "Parameter value is required"]).filter(([_name, error]) => !!error);
    if (parameterErrors.size) {
      return { parameterBindings: Object.fromEntries(parameterErrors.toArray()) };
    }
    return {};
  },
  placement: "right"
};
export default parameterSearchBarControls;
